/**
 * TanStack Query hooks for training events (milestones, medical, perfect weeks, notes).
 */

import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../client'
import type {
  TrainingEventOut,
  TrainingEventCreate,
  TrainingEventUpdate,
} from '../types'
import { useCrudMutations } from './shared'

// ── Training Events ─────────────────────────────────────────────────

/** All training events (milestones, medical, perfect weeks, notes). */
export function useEvents() {
  return useQuery({
    queryKey: ['events'],
    queryFn: () => apiFetch<TrainingEventOut[]>('/api/events'),
  })
}

function useEventMutations() {
  return useCrudMutations<TrainingEventOut, TrainingEventCreate, TrainingEventUpdate>(
    '/api/events',
    ['events'],
  )
}

export function useCreateEvent() {
  return useEventMutations().create
}

export function useUpdateEvent() {
  return useEventMutations().update
}

export function useDeleteEvent() {
  return useEventMutations().remove
}
